import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { InteractorResponse } from '../../models/interactor-response';
import { AppConstants } from '../../constants/app-constants';
import { AbstractSelfDiagnosisApiService } from '../abstract/abstract-self-diagnosis-api-service';
import { SelfDiagnosisModel, SelfDiagnosisStepRateModel } from '../../../store/self-diagnostic/self-diagnosis/model';

const baseUrl = `/api/selfDiagnosis`;

@Injectable()
export class SelfDiagnosisApiService extends AbstractSelfDiagnosisApiService {
  private http = inject(HttpClient);

  public getAll(): Observable<InteractorResponse<SelfDiagnosisModel[]>> {
    return this.http.get<InteractorResponse<SelfDiagnosisModel[]>>(`${baseUrl}`);
  }

  public getById(id: number): Observable<InteractorResponse<SelfDiagnosisModel>> {
    return this.http.get<InteractorResponse<SelfDiagnosisModel>>(`${baseUrl}/get?id=${id}`);
  }

  public update(entity: SelfDiagnosisModel): Observable<InteractorResponse<SelfDiagnosisModel>> {
    return this.http.post<InteractorResponse<SelfDiagnosisModel>>(`${baseUrl}/update`, entity);
  }

  public delete(id: number): Observable<InteractorResponse<SelfDiagnosisModel>> {
    return this.http.delete<InteractorResponse<SelfDiagnosisModel>>(`${baseUrl}/delete?id=${id}`);
  }

  public setStepRate(entity: SelfDiagnosisStepRateModel): Observable<InteractorResponse<SelfDiagnosisStepRateModel>> {
    return this.http.post<InteractorResponse<SelfDiagnosisStepRateModel>>(`${baseUrl}/rate`, entity);
  }

  public uploadIcon(entity: SelfDiagnosisModel, file: File): Observable<InteractorResponse<SelfDiagnosisModel>> {
    let formData: FormData = new FormData();

    formData.append('jsonRequest', JSON.stringify(entity));
    formData.append('file', file);

    return this.http.post<InteractorResponse<SelfDiagnosisModel>>(`${baseUrl}/uploadIcon`, formData);
  }

  public deleteIcon(entity: SelfDiagnosisModel): Observable<InteractorResponse<SelfDiagnosisModel>> {
    return this.http.post<InteractorResponse<SelfDiagnosisModel>>(`${baseUrl}/deleteIcon`, entity);
  }
}
